import { relations } from "drizzle-orm/_relations";
import {
  boolean,
  integer,
  pgTable,
  serial,
  text,
  uuid,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import { playerProfiles } from "./player-profiles";

const { createInsertSchema, createSelectSchema, createUpdateSchema } =
  createSchemaFactory({ zodInstance: z });

export const directors = pgTable("directors", {
  id: serial().primaryKey(),
  profileId: integer()
    .notNull()
    .unique()
    .references(() => playerProfiles.id, { onDelete: "cascade" }),
  // email/phoneNumber override what's shown in the UI only — notifications use the user's contact.
  email: text(),
  phoneNumber: text(),
  hidePhoneNumber: boolean().notNull().default(false),
  externalRef: uuid(),
});

export const selectDirectorSchema = createSelectSchema(directors);
export const createDirectorSchema = createInsertSchema(directors).omit({
  id: true,
});
export const updateDirectorSchema = createUpdateSchema(directors);

export type Director = z.infer<typeof selectDirectorSchema>;
export type CreateDirector = z.infer<typeof createDirectorSchema>;
export type UpdateDirector = z.infer<typeof updateDirectorSchema>;

export const directorRelations = relations(directors, ({ one }) => ({
  profile: one(playerProfiles, {
    fields: [directors.profileId],
    references: [playerProfiles.id],
  }),
}));
